import { memo } from 'react'

const ErrorDisplay = memo(({ error, onDismiss }) => {
  if (!error) return null

  return (
    <div className='error-display'>
      <span>{error}</span>
      <button onClick={onDismiss} className='error-dismiss'>
        ×
      </button>
    </div>
  )
})

export default ErrorDisplay
